module.exports = __webpack_public_path__ + "img/medical.671dcd1a.png";